<template>
  <div class="recBox">
    <div class="boxtit">
      推前次數記錄
    </div>
    <div class="property firBox">
      <el-row>
        <el-col :span="24">
          <el-input
            v-model="keyString"
            class="w380 mr4"
            placeholder="請輸入樓盤編號、訂單編號"
            suffix-icon="el-icon-search"
          />
          <el-select
            v-model="accountName"
            class="w160 mr4"
            filterable
            remote
            :remote-method="(query)=>{remoteMethods(query,'accountName')}"
            placeholder="請輸入放盤人姓名"
            clearable
            @visible-change="clearNo"
          >
            <el-option
              v-for="item in nameOptions"
              :key="item.index"
              :label="item.accountName"
              :value="item.accountName"
            />
          </el-select>
          <el-select
            v-model="createAccountName"
            class="w160 mr4"
            filterable
            remote
            :remote-method="(query)=>{remoteMethods(query,'createAccountName')}"
            placeholder="請輸入操作人姓名"
            clearable
            @visible-change="clearNo"
          >
            <el-option
              v-for="item in accountNameOptions"
              :key="item.index"
              :label="item.createAccountName"
              :value="item.createAccountName"
            />
          </el-select>

          <el-select
            v-model="sourceType"
            class="w150 seled"
            placeholder="請選擇記錄類型"
          >
            <el-option
              v-for="item in recStatusList"
              :key="item.dictionaryValue"
              :label="item.dictionaryNameWithCulture"
              :value="item.dictionaryValue"
            />
          </el-select>
        </el-col>
        <el-col>
          記錄時間：
          <el-date-picker
            v-model="startTime"
            format="yyyy/MM/dd"
            value-format="timestamp"
            class="w150 mr4"
            type="date"
            :picker-options="startTimeOption"
            placeholder="選擇日期"
          />—
          <el-date-picker
            v-model="endTime"
            format="yyyy/MM/dd"
            value-format="timestamp"
            class="w150"
            :picker-options="endTimeOption"
            type="date"
            placeholder="選擇日期"
          />
          <el-button
            type="danger"
            class="seaButton"
            @click="clickSearch"
          >
            查詢
          </el-button>
          <el-button
            type="info"
            @click="resetSearch"
          >
            重置
          </el-button>
          <el-button
            type="info"
            class="decButton"
            @click="showDia"
          >
            導出
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-table
        v-loading="listLoading"
        :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }"
        :data="tableData"
        style="width: 100%"
        fit
      >
        <el-table-column label="記錄時間">
          <template slot-scope="scope">
            {{ scope.row.createTime ? scope.row.createTime.replace(/T/, ' ') : scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sourceTypeWithCulture"
          label="記錄類型"
        />
        <!-- <el-table-column prop="orderId" label="訂單編號">
                    <template slot-scope="scope">
                        {{ scope.row.orderId ? scope.row.orderId : '-' }}
                    </template>
                </el-table-column> -->
        <el-table-column
          prop="propertyID"
          label="樓盤編號"
        />
        <el-table-column label="次數">
          <template slot-scope="scope">
            <span :class="color(scope.row.recommendNumber)">{{ scope.row.recommendNumber>0?'+'+scope.row.recommendNumber:scope.row.recommendNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accountName"
          label="放盤人"
        />
        <el-table-column
          prop="createAccountName"
          label="操作人"
        />
      </el-table>
      <pagination
        class="bottom-right"
        :total="total"
        :page.sync="pageIndex"
        :limit.sync="pageCount"
        @pagination="loadRecommendList"
      />
    </div>
    <el-dialog
      class="ti-me"
      title="選擇導出日期"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div>
        <span>選擇日期：&nbsp;&nbsp;</span>
        <span class="block">
          <span>
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              style="width: 250px"
              value-format="timestamp"
            />
          </span>
          <p
            v-if="warnShow"
            class="selDat"
          >請選擇日期</p>
        </span>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="depExc"
        >確 認</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import XLSX from 'xlsx';

export default {
    components: { Pagination },
    data() {
        return {
            total: 0,
            startTime: '',
            endTime: '',
            orderId: '',
            accountName:'',
            createAccountName:'',
            sourceType:null,
            keyString: '',
            pageIndex: 1,
            pageCount: 20,
            startTimeOption: {
                disabledDate: this.startTimeOption1
            },
            endTimeOption: {
                disabledDate: this.endTimeOption1
            },
            tableData: [],
            recStatusList: [],
            accountNameOptions:[],
            nameOptions:[],
            dialogVisible: false,
            value1: [],
            warnShow: false
        };
    },
    created() {
        this.keyString = this.$route.query.propertyId
        this.loadRecommendList();
        this.pub.getDictionary().then(res => {
            this.recStatusList = res.RecommendLogSourceType.children;
        });
    },
    methods: {
        showDia(){
            this.dialogVisible = true
            this.value1= []
        },
        clearNo(visible){
            if(!visible){
                this.accountNameOptions =[]
                this.nameOptions = [];
            }
        },
        remoteMethods(query,type) {
            let nameArr = type == 'accountName' ? 'nameOptions':'accountNameOptions'
       		if (query !== "") {
                return this.getStaffOptions(query,type);
            } 
                this[nameArr]=[]
            
        },
        unique(arr,type) {
            let nameArr = type == 'accountName' ? 'nameOptions':'accountNameOptions'
            let obj = {};
            let peon = arr.reduce((cur, next) => {
                // obj[next[type]] ? "" : obj[next[type]] = true && cur.push(next);
                if (!obj[next[type]]) {
                  obj[next[type]] = true;
                  cur.push(next);
                }
                return cur;
            }, [])
            this[nameArr] = peon
        },
        getStaffOptions(query,type){
            let nameArr = type == 'accountName' ? 'nameOptions':'accountNameOptions'
            let data = {}
            if(type == 'accountName'){
                data = {
                    pageIndex:1,
                    pageCount:100,
                    accountName:query
                }
            }else{
                data = {
                    pageIndex:1,
                    pageCount:100,
                    createAccountName:query
                }
            }
            
            this.axios.post(this.pub.getApi().SearchRecommendLogs, data).then(res => {
                let recArr = []
                if (res.data.code === 0) {
                    for (let i in res.data.result.data) {
                        if (res.data.result.data[i][type] !== null && res.data.result.data[i][type] !== undefined && res.data.result.data[i][type] !== '') {
                            recArr.push(res.data.result.data[i]);
                        }
                    }
                    this.unique(recArr,type)
                } else {
                    this[nameArr]=[]
                }
                return this[nameArr]
            });
        },
        color(val) {
            return val >=0 ? 'green':'red'
        },
        // 置顶excel记录导出
        async depExc() {
            this.warnShow = !this.value1 || !this.value1.length
            if(this.warnShow){return}
            let recData = [];
            await this.axios
                .post(this.pub.getApi().SearchAllRecommendLogs, {
                    pageIndex: 1,
                    pageCount: 20,
                    startTime: this.value1 ? this.value1[0] / 1000 : '',
                    endTime: this.value1 ? this.value1[1] / 1000 + 86400 : ''
                })
                .then(res => {
                    if (res.data.code == 0 && res.data.result.length) {
                        recData = res.data.result;
                        const loading = this.$loading({
                            lock: true,
                            text: '正在努力導出數據,大約會耗時幾分鐘，請不要關閉當前網頁',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        let arr = [];
                        recData.forEach(item => {
                            let obj = {};
                            obj.記錄時間 = item.createTime.replace(/T/, ' ');
                            obj.記錄類型 = item.sourceTypeWithCulture;
                            // obj.訂單編號 = item.orderId;
                            obj.樓盤編號 = item.propertyID;
                            obj.次數 = item.recommendNumber>0 ? '+'+item.recommendNumber : String(item.recommendNumber);
                            obj.放盤人 = item.accountName;
                            obj.操作人 = item.createAccountName;
                            arr.push(obj);
                        });
                        let header = { header: ['記錄時間', '記錄類型',  '樓盤編號', '次數', '放盤人', '操作人'] };
                        const ws = XLSX.utils.json_to_sheet(arr, header);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, '重新推前次數記錄');
                        XLSX.writeFile(wb, '重新推前次數記錄.xlsx');
                        loading.close();
                        this.dialogVisible = false
                    } else {
                        this.$message({
                            message: `未有訂單記錄可導出`,
                            type: 'error',
                            customClass:'errorMes',
                            center:true
                        });
                    }
                });
        },
        startTimeOption1(time) {
            if (this.endTime) {
                return time.getTime() > this.endTime || time.getTime() < (new Date()).getTime()-365*2*24*3600*1000;
            } 
                return time.getTime() < (new Date()).getTime()-365*2*24*3600*1000;
            
        },
        endTimeOption1(time) {
            if (this.startTime) {
                return time.getTime() < this.startTime;
            } 
                return time.getTime() < (new Date()).getTime()-365*2*24*3600*1000;
            
        },
        getSearchValue() {
            const data = {};
            data.pageIndex = this.pageIndex;
            data.pageCount = this.pageCount;
            if (this.orderId) {data.orderId = this.orderId;}
            if (this.keyString) {data.keyString = this.keyString;}
            if (this.propertyId) {data.propertyId = this.propertyId;}
            if (this.sourceType) {data.sourceType = this.sourceType;}
            if (this.accountName) {data.accountName = this.accountName;}
            if (this.createAccountName) {data.createAccountName = this.createAccountName;}
            if (this.startTime) {data.startTime = this.startTime / 1000;}
            if (this.endTime) {data.endTime = this.endTime / 1000 + 24 * 60 * 60;}
            return data;
        },
        clickSearch() {
            this.pageIndex = 1;
            this.loadRecommendList();
        },
        resetSearch() {
            this.orderId = '';
            this.keyString = '';
            this.propertyId = '';
            this.sourceType = null;
            this.accountName = '';
            this.createAccountName = '';
            this.startTime = '';
            this.endTime = '';
            this.clickSearch();
        },
        loadRecommendList() {
            this.listLoading = true;
            const data = this.getSearchValue();
            this.axios.post(this.pub.getApi().SearchRecommendLogs, data).then(res => {
                if (res.data.code == 0) {
                    this.tableData = res.data.result.data;
                    this.total = res.data.result.count;
                    this.listLoading = false;
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.recBox {
    .selDat {
        color: red;
        margin-left:80px;
    }
    .ti-me {
        text-align:left;
        /deep/.el-dialog {
            border-radius: 8px;
            .el-button {
                border-radius: 10px;
            }
        }
        /deep/.el-dialog__body {
            padding-left:60px;
        }
        /deep/.el-dialog__header {
            padding: 9px 32px;
            background: rgb(250 250 251);
            border-bottom: 1px solid rgb(226 226 234);
            border-radius: 8px 8px 0 0;
            text-align:left;
            /deep/.el-dialog__title {
                font-size: 16px;
                color: rgb(102 102 102);
            }
        }
        i.el-icon-close {
            position: absolute;
            top: -7px;
            left: -8px;
        }
    }
    .boxtit {
        text-align: left;
        font-size: 24px;
        color: #171725;
        margin-bottom: 20px;
    }

    button {
        border-radius: 10px;
        width: 88px;
        height: 38px;
    }
    .w380 {
        width: 380px;
    }
    .w160{
        width: 160px;
    }
    .w150 {
        width: 150px;
        margin-bottom: 10px;
    }
    .mr4 {
        margin-right: 15px;
    }
    .seled {
        ::placeholder {
            color: #000000;
        }
    }
    .firBox {
        text-align: left;
        .seaButton {
            margin-left: 10px;
        }
        .decButton{
            background-color: #E1c999;
            border:none;
        }
        /deep/.el-input__inner {
            border-radius: 10px;
            border: none;
            color: #000;
        }
    }
    .container {
        margin-top: 20px;
        background-color: #ffffff;
        padding: 20px 20px 0 20px;
        border-radius: 10px;
        height: calc(100% - 80px);
        /deep/table {
            color: #222;
            font-size: 14px;
            tr th .cell {
                // font-weight: normal;
                font-size: 12px;
                color: #44444f;
            }
        }
        .red {
            color: #e50113;
        }
        .green {
            color: green;
        }
        .bottom-right {
            text-align: right;
        }
        /deep/.el-table__header-wrapper {
            border-radius: 10px;
            height: 38px;
        }
    }
}
</style>
